import React, { FunctionComponent } from "react";
import { FieldAttributes, Field, FieldProps, ErrorMessage } from "formik";
import InputMask from "react-input-mask";
import "./dateField.css";

export const DateField: FunctionComponent<FieldAttributes<any>> = ({ name, ...props }) => {
  return (
    <Field name={name}>
      {({ field, meta: { error } }: FieldProps) => (
        <div className={`dateField ${error ? "error" : ""}`}>
          <InputMask {...field} {...props} value={field.value || ""} mask="99/99/9999" />
          <ErrorMessage name={name} />
        </div>
      )}
    </Field>
  );
};

DateField.displayName = "DateField";
